import { motion } from "framer-motion";

export default function PageHero({ image, imageAlt, eyebrow, title, sub, testid }) {
  return (
    <section data-testid={testid} className="relative flex h-[62vh] min-h-[420px] items-end overflow-hidden">
      <img src={image} alt={imageAlt} fetchPriority="high" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-b from-charcoal/70 via-charcoal/30 to-charcoal" />
      <div className="relative z-10 mx-auto w-full max-w-7xl px-6 pb-16 sm:px-12 lg:px-20">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
          className="text-xs font-medium uppercase tracking-[0.3em] text-brass"
        >
          {eyebrow}
        </motion.p>
        <div className="overflow-hidden">
          <motion.h1
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1, delay: 0.35, ease: [0.16, 1, 0.3, 1] }}
            className="mt-4 max-w-3xl font-serif text-4xl font-light leading-[1.08] tracking-tight text-ivory sm:text-5xl lg:text-6xl"
          >
            {title}
          </motion.h1>
        </div>
        {sub && (
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.7, ease: [0.16, 1, 0.3, 1] }}
            className="mt-5 max-w-xl text-sm font-light leading-relaxed text-ivory/80 sm:text-base"
          >
            {sub}
          </motion.p>
        )}
      </div>
    </section>
  );
}
